import { Component, Input } from '@angular/core';

@Component({
  selector: 'mw-data-sheet',
  templateUrl: 'data-sheet.component.html',
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 500px;
      }
    `,
  ],
})
export class DataSheetComponent {
  displayedColumns: string[] = ['key', 'value'];
  @Input() set data(value: any) {
    if (value) {
      this.normalizedData = Object.entries(value).map((item) => ({
        key: item[0],
        value: item[1],
      }));
    } else {
      this.normalizedData = [];
    }
  }

  normalizedData: { key: any; value: any }[] = [];
}
